import React, { useMemo } from "react";
import "./RatingBreakdown.css";

export default function RatingBreakdown({ rateDetail, rateCount = 0 }) {
  const rows = useMemo(() => {
    const byRate = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

    if (Array.isArray(rateDetail)) {
      rateDetail.forEach((r) => {
        const stars = Number(r?.rate ?? r?.stars);
        const count = Number(r?.count ?? 0);
        if (stars >= 1 && stars <= 5) byRate[stars] = count;
      });
    } else if (rateDetail && typeof rateDetail === "object") {
      Object.entries(rateDetail).forEach(([k, v]) => {
        const stars = Number(k);
        const count = Number(v ?? 0);
        if (stars >= 1 && stars <= 5) byRate[stars] = count;
      });
    }

    return [5, 4, 3, 2, 1].map((star) => ({
      rate: star,
      count: byRate[star] || 0,
    }));
  }, [rateDetail]);

  const total = rateCount || rows.reduce((sum, r) => sum + r.count, 0);

  return (
    <div className="rating-breakdown">
      {rows.map(({ rate, count }) => {
        const pct = total > 0 ? Math.round((count / total) * 100) : 0;

        return (
          <div className="rb-row" key={rate}>
            {/* Star label */}
            <div className="rb-label">{rate}★</div>

            {/* Middle track + fill */}
            <div className="rb-track" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
              <div className={`rb-fill star-${rate}`} style={{ width: `${pct}%` }} />
            </div>

            {/* Reviews count */}
            <div className="rb-count">{count}</div>
          </div>
        );
      })}
    </div>
  );
}
